var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseInlineSwitch',{attrs:{"section-name":_vm.sectionName,"label":"canceled"},model:{value:(_vm.showCanceled),callback:function ($$v) {_vm.showCanceled=$$v},expression:"showCanceled"}})
}
var staticRenderFns = []

export { render, staticRenderFns }